module.exports = __webpack_public_path__ + "static/img/articleguest1.923f405.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/propaganda/articleguest1.jpg
// module id = CB14
// module chunks = 1